import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TextareaAutosize } from '@mui/material';
import { styled } from '@mui/material/styles';
import { handleEnterKeyPress } from '../../../../lib/commonUtils';
import { toggleSummaryEdit, updateSummary } from '../../selectedVideoSlice';
import { RootState } from '../../../../reducers';
import { useTheme } from '../../../../theme/ThemeContext';

const DescriptionTextArea = styled(TextareaAutosize)(({ theme }) => ({
  lineHeight: '24px',
  backgroundColor: 'transparent',
  width: '100%',
  border: 0,
  fontSize: '1rem',
  resize: 'none',
  padding: theme.spacing(1.5),
  color: theme.palette.text.primary,
  '&:focus': {
    outline: 'none',
  },
}));

export const SummaryEditable = () => {
  const { selectedVideo } = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const { text } = selectedVideo.summary;
  const { _id: fileId } = selectedVideo.file;
  const [tempDescription, setTempDescription] = useState(text);
  const { isDarkMode } = useTheme();

  const onUpdate = (newSummary: string) => {
    dispatch(
      updateSummary({
        fileId,
        summary: newSummary,
      })
    );
  };

  const handleDescriptionUpdate = () => {
    dispatch(toggleSummaryEdit());
    if (tempDescription && tempDescription !== text) {
      onUpdate(tempDescription);
    }
  };

  useEffect(() => {
    setTempDescription(text);
  }, [text]);

  return (
    <DescriptionTextArea
      value={tempDescription}
      onChange={(e) => setTempDescription(e.target.value)}
      onFocus={(e) => e.target.select()}
      onKeyDown={handleEnterKeyPress(handleDescriptionUpdate)}
      onBlur={handleDescriptionUpdate}
      sx={{
        fontSize: '0.875rem',
        fontFamily: 'Inter, sans-serif',
        paddingBottom: 0,
        color: isDarkMode ? 'text.primary' : 'text.primary',
        '&::placeholder': {
          color: isDarkMode ? 'text.secondary' : 'text.secondary',
        },
      }}
    />
  );
};

export default SummaryEditable;
